var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p-dialog',{attrs:{"visible":_vm.value,"modal":"","dismissableMask":"","header":_vm.title,"contentStyle":_vm.contentStyle},on:{"update:visible":_vm.onInput,"show":_vm.onShow}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }